"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.donorsUpdate = exports.donorsSuccess = exports.donorsReset = exports.donorsListBysearch = exports.donorsListByIdYear = exports.donorsError = exports.donorsDeleteAll = exports.donorsDelete = exports.donorsCreate = exports.donorsBulkDelete = exports.donorSoftDeletedList = exports.donorSoftDelete = exports.donorRestore = exports.donorBulkSoftDelete = exports.donorBulkRestore = void 0;
var _donors = require("./donors.constant");
// common success
var donorsSuccess = function donorsSuccess(actionType, data) {
  return {
    type: _donors.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.donorsSuccess = donorsSuccess;
var donorsError = function donorsError(actionType, error) {
  return {
    type: _donors.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * search doners list with params
 * @param payload
 * @returns api response
 * @description this function used to search doners with params.
 */
exports.donorsError = donorsError;
var donorsListBysearch = function donorsListBysearch(data) {
  return {
    type: _donors.actionTypes.LIST_BY_SEARCH,
    payload: data
  };
};

/**
 * doners list search by id and year
 * @param payload
 * @returns api response
 * @description this function used to doners list by id and year.
 */
exports.donorsListBysearch = donorsListBysearch;
var donorsListByIdYear = function donorsListByIdYear(data) {
  return {
    type: _donors.actionTypes.DONORS_LIST_BY_ID_YEAR,
    payload: data
  };
};

/**
 * doner update api
 * @param payload
 * @returns api response
 * @description this function used to update doners input.
 */
exports.donorsListByIdYear = donorsListByIdYear;
var donorsUpdate = function donorsUpdate(data) {
  return {
    type: _donors.actionTypes.UPDATE,
    payload: data
  };
};

/**
 * doners create
 * @param payload
 * @returns api response
 * @description this function used to doner create given inputs.
 */
exports.donorsUpdate = donorsUpdate;
var donorsCreate = function donorsCreate(data) {
  return {
    type: _donors.actionTypes.CREATE,
    payload: data
  };
};

/**
 * doners delete
 * @param payload
 * @returns api response
 * @description this function used to doner delete given id.
 */
exports.donorsCreate = donorsCreate;
var donorsDelete = function donorsDelete(data) {
  return {
    type: _donors.actionTypes.DELETE,
    payload: data
  };
};

/**
 * doners bulk delete
 * @param payload
 * @returns api response
 * @description this function used to delete bulk doners of given id.
 */
exports.donorsDelete = donorsDelete;
var donorsBulkDelete = function donorsBulkDelete(data) {
  return {
    type: _donors.actionTypes.BULK_DELETE,
    payload: data
  };
};

/**
 * doners delete
 * @param payload
 * @returns api response
 * @description this function used to doner delete all.
 */
exports.donorsBulkDelete = donorsBulkDelete;
var donorsDeleteAll = function donorsDeleteAll(data) {
  return {
    type: _donors.actionTypes.DELETE_ALL,
    payload: data
  };
};

/**
 * doners reset
 * @param payload
 * @returns api response
 * @description this function used to doner reset.
 */
exports.donorsDeleteAll = donorsDeleteAll;
var donorsReset = function donorsReset(data) {
  return {
    type: _donors.actionTypes.RESET,
    payload: data
  };
};
exports.donorsReset = donorsReset;
var donorSoftDelete = function donorSoftDelete(data) {
  return {
    type: _donors.actionTypes.SOFT_DELETE_DONOR,
    payload: data
  };
};
exports.donorSoftDelete = donorSoftDelete;
var donorRestore = function donorRestore(data) {
  return {
    type: _donors.actionTypes.RESTORE_SOFT_DELETE_DONOR,
    payload: data
  };
};
exports.donorRestore = donorRestore;
var donorSoftDeletedList = function donorSoftDeletedList(data) {
  return {
    type: _donors.actionTypes.LIST_RESTORE_SOFT_DELETE_DONOR,
    payload: data
  };
};
exports.donorSoftDeletedList = donorSoftDeletedList;
var donorBulkSoftDelete = function donorBulkSoftDelete(data) {
  return {
    type: _donors.actionTypes.BULK_SOFT_DELETE,
    payload: data
  };
};
exports.donorBulkSoftDelete = donorBulkSoftDelete;
var donorBulkRestore = function donorBulkRestore(data) {
  return {
    type: _donors.actionTypes.BULK_RESTORE,
    payload: data
  };
};
exports.donorBulkRestore = donorBulkRestore;